import { useEffect, useRef, useState } from 'react';
import audioEffect from '~/assets/mp3/Track_C_mp3.mp3';

// Global variables to track currently active phone audio effect
let currentActivePhoneId: string | null = null;
let currentActiveAudio: HTMLAudioElement | null = null;

export function usePhoneAudioEffect(editorMode?: boolean) {
  const audioRef = useRef<HTMLAudioElement>();
  const phoneIdRef = useRef<string>(
    `phone-audio-effect-${Math.random().toString(36).substr(2, 9)}`
  );
  const [pauseAudioEffect, setPauseAudioEffect] = useState(false);
  const audioEffectDuration = 5000; // 5 seconds

  useEffect(() => {
    if (editorMode) {
      return;
    }

    const audio = new Audio(audioEffect);
    audio.load();
    audio.loop = true;

    setTimeout(() => {
      audio.loop = false;
    }, audioEffectDuration);

    audioRef.current = audio;
    return () => {
      audioRef?.current?.pause();
    };
  }, []);

  useEffect(() => {
    if (editorMode) {
      return;
    }

    if (!pauseAudioEffect) {
      if (currentActiveAudio && currentActiveAudio !== audioRef.current) {
        currentActiveAudio.pause();
      }

      currentActivePhoneId = phoneIdRef.current;
      currentActiveAudio = audioRef.current || null;

      audioRef?.current?.play().catch(error => {
        // Silently handle autoplay restrictions
      });
    } else {
      audioRef?.current?.pause();
      if (currentActiveAudio === audioRef.current) {
        currentActivePhoneId = null;
        currentActiveAudio = null;
      }
    }

    return () => {
      audioRef?.current?.pause();
    };
  }, [audioRef.current, pauseAudioEffect]);

  const pausePhoneAudioEffect = () => {
    setPauseAudioEffect(true);
  };

  return {
    audioEffectDuration,
    phoneAudioEffectIsPaused: pauseAudioEffect,
    pausePhoneAudioEffect
  };
}
